// extracted by mini-css-extract-plugin
export default {"searchInput":"WebsitesCollectionControlBar_searchInput__K9M7s"};